import React, { useEffect, useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';

// Counts down to FIFA World Cup 2026 inaugural match: México vs Sudáfrica, Estadio Azteca, June 11, 2026 13:00 CDMX (GMT-6 = 19:00 UTC)
const TARGET = new Date('2026-06-11T19:00:00Z');

const calc = () => {
  const diff = TARGET.getTime() - Date.now();
  if (diff <= 0) return { d: 0, h: 0, m: 0, s: 0, done: true };
  const d = Math.floor(diff / 86400000);
  const h = Math.floor((diff % 86400000) / 3600000);
  const m = Math.floor((diff % 3600000) / 60000);
  const s = Math.floor((diff % 60000) / 1000);
  return { d, h, m, s, done: false };
};

const Cell = ({ value, label, accent }) => (
  <div className="flex flex-col items-center min-w-[44px] sm:min-w-[60px]">
    <span
      className={`font-comfortaa font-bold tabular-nums leading-none text-2xl sm:text-3xl ${
        accent ? 'text-lime' : 'text-white'
      }`}
    >
      {String(value).padStart(2, '0')}
    </span>
    <span className="mt-1 text-[9px] sm:text-[10px] font-mont uppercase tracking-[0.18em] text-white/55">
      {label}
    </span>
  </div>
);

const WorldCupCountdown = () => {
  const { t } = useLanguage();
  const [tk, setTk] = useState(calc);

  useEffect(() => {
    const id = setInterval(() => setTk(calc()), 1000);
    return () => clearInterval(id);
  }, []);

  if (tk.done) return null;

  return (
    <div
      className="relative bg-black text-white border-b border-white/5"
      data-testid="worldcup-countdown-bar"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 sm:py-4 flex items-center justify-center gap-3 sm:gap-6 flex-wrap">
        <div className="flex items-center gap-2">
          <span className="w-2 h-2 rounded-full bg-lime animate-pulse" />
          <span className="font-comfortaa font-bold text-[10px] sm:text-xs tracking-[0.2em] uppercase text-lime">
            {t('cdLabel')}
          </span>
          <span className="hidden sm:inline text-xs font-mont font-light text-white/55">
            · {t('cdSubtitle')}
          </span>
        </div>

        <div className="flex items-center gap-2 sm:gap-4">
          <Cell value={tk.d} label={t('cdDays')} accent />
          <span className="text-white/30 font-comfortaa font-bold text-xl sm:text-2xl leading-none -mt-2">:</span>
          <Cell value={tk.h} label={t('cdHours')} />
          <span className="text-white/30 font-comfortaa font-bold text-xl sm:text-2xl leading-none -mt-2">:</span>
          <Cell value={tk.m} label={t('cdMinutes')} />
          <span className="text-white/30 font-comfortaa font-bold text-xl sm:text-2xl leading-none -mt-2 hidden sm:inline">:</span>
          <Cell value={tk.s} label={t('cdSeconds')} />
        </div>
      </div>
    </div>
  );
};

export default WorldCupCountdown;
